import { shareInfoService, storeService, } from '@/services';
import ShareInfoConfigVM from '@/view-model/share-management/ShareInfoConfigVM';
import StoreVM from '@/view-model/store-management/StoreVM';
import { whereOperators } from '@/lib/query-parameter/filter';
import { storeStatusOptionList } from '@/constants/storeManagement';
import shareStoreTableType from '@/constants/shareManagement/shareStoreTableType';
import { vuexEventPathGenerator } from '@/utils';
import { i18n } from '@/locales';
import { createShareConfigFormData as createFormData } from '@/form/form-data';
import { objDeepCompare } from '@/utils/object';
import { alertActionType } from '@/vuex-store/alert/actions';
import { mutationType } from './mutations';
import { getterType } from './getters';
export const actionType = {
    getShareInfoConfig: 'getShareInfoConfig',
    /** 허브의 상점 리스트 */
    getHubStoreList: 'getHubStoreList',
    setHubStoreList: 'setHubStoreList',
    /** 등록된 발주 허브 공유 상점 */
    setRegisteredShareStoreList: 'setRegisteredShareStoreList',
    setHubStoreCheckedList: 'setHubStoreCheckedList',
    setRegisteredShareStoreCheckedList: 'setRegisteredShareStoreCheckedList',
    setHubStoreSearchOption: 'setHubStoreSearchOption',
    setRegisteredShareStoreSearchOption: 'setRegisteredShareStoreSearchOption',
    resetShareInfoConfig: 'resetShareInfoConfig',
    postShareInfoConfig: 'postShareInfoConfig',
    selectedShareHubId: 'selectedShareHubId',
    setFormValue: 'setFormValue',
    checkOriginData: 'checkOriginData',
    compareOriginWithFormData: 'compareOriginWithFormData',
    initFormData: 'initFormData',
};
// const route = useRoute();
export const shareConfigActionType = vuexEventPathGenerator(actionType, 'shareManagement/shareConfig');
const lc = 'views.share_management.';
const action = {
    [actionType.selectedShareHubId]({ commit }, payload) {
        commit(mutationType.SELECTED_SHARE_HUB_ID, payload);
    },
    async [actionType.getHubStoreList]({ commit, getters, rootGetters, }) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const [, ON,] = storeStatusOptionList;
        const filters = [
            {
                condition: whereOperators.equals,
                field: ON.field,
                value: ON.value,
            },
        ];
        const { list } = await storeService.getHubStoreList({
            hubId,
            filters,
            pageNumber: 1,
            pageSize: 10_000,
        });
        const storeList = list.map((info) => {
            const { validatedStoreCode, validatedStoreName } = new StoreVM(info);
            return {
                storeId: validatedStoreCode,
                storeName: validatedStoreName,
            };
        });
        commit(mutationType.GET_SUBSCRIBE_HUB_TOTAL_STORE_LIST, storeList);
        commit(mutationType.SET_SUBSCRIBE_HUB_STORE_LIST, getters[getterType.getterHubStoreList]);
    },
    async [actionType.getShareInfoConfig]({ commit, rootGetters, getters }, agencyHubId = '') {
        try {
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            const distributorId = rootGetters['hubSelector/getterSubscribeDistributorHubId'];
            const { data } = await shareInfoService.getShareInfoConfig({
                hubId: distributorId ?? hubId,
                agencyHubId,
            });
            const shareInfo = new ShareInfoConfigVM(data);
            if (!shareInfo.hubId) {
                shareInfo.hubId = agencyHubId;
            }
            commit(mutationType.GET_SHARE_INFO_CONFIG, shareInfo);
            commit(mutationType.SET_REGISTERED_SHARE_STORE_LIST, shareInfo.formattedStores);
            commit(mutationType.SET_SUBSCRIBE_HUB_STORE_LIST, getters.getterHubStoreList);
            commit(mutationType.SET_SUBSCRIBE_HUB_STORE_SEARCH_OPTION, {
                value: '',
            });
            commit(mutationType.SET_REGISTERED_SHARE_STORE_SEARCH_OPTION, {
                value: '',
            });
            commit(mutationType.SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST, []);
            commit(mutationType.SET_REGISTERED_SHARE_STORE_CHECKED_LIST, []);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            return {
                isSuccess: false,
                reason,
                message,
            };
        }
    },
    async [actionType.setRegisteredShareStoreList]({ commit, getters, state }, { isDelete, tableType, }) {
        const registeredList = state.registeredShareStoreInfo.list;
        let result = registeredList;
        if (isDelete) {
            result = registeredList.filter((subscribeInfo) => {
                const isExisted = getters.getterRegisteredShareStoreCheckedList.some((registeredInfo) => subscribeInfo.storeId === registeredInfo.storeId);
                return !isExisted;
            });
        }
        else if (!isDelete && getters.getterHubStoreCheckedListLength > 0) {
            result = registeredList.concat(getters.getterHubStoreCheckedList);
        }
        if (tableType === shareStoreTableType.SUBSCRIBE) {
            commit(mutationType.SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST, []);
        }
        if (tableType === shareStoreTableType.REGISTERED) {
            commit(mutationType.SET_REGISTERED_SHARE_STORE_CHECKED_LIST, []);
        }
        commit(mutationType.SET_REGISTERED_SHARE_STORE_LIST, result);
        commit(mutationType.SET_SUBSCRIBE_HUB_STORE_LIST, getters.getterHubStoreList);
    },
    async [actionType.setHubStoreList]({ commit }, shareStoreList) {
        commit(mutationType.SET_SUBSCRIBE_HUB_STORE_LIST, shareStoreList);
    },
    async [actionType.setHubStoreCheckedList]({ commit }, shareStoreList) {
        commit(mutationType.SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST, shareStoreList);
    },
    async [actionType.setRegisteredShareStoreCheckedList]({ commit }, shareStoreList) {
        commit(mutationType.SET_REGISTERED_SHARE_STORE_CHECKED_LIST, shareStoreList);
    },
    async [actionType.setHubStoreSearchOption]({ commit }, searchOption) {
        commit(mutationType.SET_SUBSCRIBE_HUB_STORE_CHECKED_LIST, []);
        commit(mutationType.SET_SUBSCRIBE_HUB_STORE_SEARCH_OPTION, searchOption);
    },
    async [actionType.setRegisteredShareStoreSearchOption]({ commit }, searchOption) {
        commit(mutationType.SET_REGISTERED_SHARE_STORE_CHECKED_LIST, []);
        commit(mutationType.SET_REGISTERED_SHARE_STORE_SEARCH_OPTION, searchOption);
    },
    async [actionType.resetShareInfoConfig]({ commit, }) {
        commit(mutationType.RESET_SHARE_INFO_CONFIG);
    },
    async [actionType.postShareInfoConfig]({ state }, { hubId, shareInfo, }) {
        try {
            // 발주 가맹점 전체 공유설정/삭제 방법: https://www.notion.so/b02d8308a71f4d14a7ef0228fa5695c6?pvs=4#a50dc5cc7a6e4f7ca730ef08e3f1953f
            const storeIds = state.registeredShareStoreInfo.list.map((info) => info.storeId);
            const isMutualShared = storeIds.length === state.totalSubscribeHubStoreList.length;
            const shareInfoReq = {
                ...shareInfo,
                isMutualShared,
            };
            if (!isMutualShared) {
                shareInfoReq.storeIds = storeIds.length > 0 ? storeIds : null;
            }
            const { data } = await shareInfoService.postShareInfoConfig({
                hubId,
                shareInfo: shareInfoReq,
            });
            return data;
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            return {
                isSuccess: false,
                reason,
                message,
            };
        }
    },
    async [actionType.setFormValue]({ commit }, payload) {
        commit(mutationType.SET_FORM_VALUE, payload);
    },
    /**
     * 폼 데이터 초기화
     */
    async [actionType.initFormData]({ state }, isInitOriginFormData) {
        state.isConfigBefore = false;
        const data = isInitOriginFormData ? state.originFormData : state.formData;
        const newFormData = createFormData();
        // Object.entries(getterShareInfoConfig.value ?? {}).reduce(
        Object.entries(state.shareInfoConfig ?? {}).reduce((acc, [key, value,]) => {
            const replacedKey = key.replace('_', '');
            // 공유 상점 목록의 경우 getterRegisteredShareStoreList에서 관리하므로 formData에 추가하지 않는다
            if (replacedKey === 'stores') {
                if (value.length > 0) {
                    // 상점 리스트가 있다면 설정한 적 있는 것으로 판단
                    state.isConfigBefore = true;
                }
                return acc;
            }
            if (value === null) {
                acc[replacedKey] = newFormData[replacedKey];
                return acc;
            }
            if (replacedKey === 'hubId') {
                // 페이지 최초 진입 시 getShareInfoConfig 응답 api에 과거 설정 내역이 없는 경우 hubId가 undefined이므로 임의로 params 값 추가하기
                // const { agencyHubId } = route.params;
                // acc.agencyHubId = state.formData.agencyHubId ?? agencyHubId;
                acc.agencyHubId = state.formData.agencyHubId;
                return acc;
            }
            acc[replacedKey] = value;
            return acc;
        }, data);
    },
    async [actionType.compareOriginWithFormData]({ state, dispatch, getters }) {
        await dispatch(actionType.initFormData, true);
        const isSameFormData = objDeepCompare(state.originFormData, state.formData);
        const isSameStoreList = objDeepCompare(getters.getterCurrentShareInfoConfigStoreList, getters.getterCurrentRegisteredShareStoreInfoList);
        return isSameFormData && isSameStoreList;
    },
    /**
     * 최초값과 비교하여 변경된 데이터가 있는지 확인
     */
    async [actionType.checkOriginData]({ state, dispatch }) {
        const isSame = await dispatch(actionType.compareOriginWithFormData);
        if (isSame) {
            return true;
        }
        const headerTitle = state.isConfigBefore
            ? `${i18n.t(`${lc}share_config`)} ${i18n.t('common.modify')} ${i18n.t('common.cancel')}`
            : `${i18n.t(`${lc}share_config`)} ${i18n.t('common.register')} ${i18n.t('common.cancel')}`;
        return dispatch(alertActionType.confirm, {
            headerTitle,
            bodyContent: i18n.t('common.confirm_before_cancel'),
            btnConfig: [
                {
                    text: 'cancel',
                    cssClass: 'outlined info',
                },
                {
                    text: 'ok',
                    cssClass: 'danger',
                },
            ],
        }, {
            root: true,
        });
    },
};
export default action;
